module.exports = __webpack_public_path__ + "img/oah-landing-about.9d974fc0.svg";